import { Controller } from "@hotwired/stimulus"

// Controller genérico para file upload con feedback visual.
// Muestra el nombre del archivo seleccionado en un target label.
//
// Uso en HTML:
//   <div data-controller="manage--file-upload">
//     <div data-manage--file-upload-target="label">Seleccionar archivo</div>
//     <input type="file" data-manage--file-upload-target="input"
//            data-action="change->manage--file-upload#select" class="hidden">
//   </div>
export default class extends Controller {
  static targets = ["label", "input"]
  static values = { placeholder: { type: String, default: "Seleccionar archivo" } }

  select() {
    const file = this.inputTarget.files[0]
    this.labelTarget.textContent = file ? file.name : this.placeholderValue
  }
}
